import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type DeleteCategoryDimensionPayload = {
	categoryDimensionUID: string;
};

const deleteCategoryDimension = async (payload: DeleteCategoryDimensionPayload): Promise<any> => {
	const response = await apiDal.post("/categorydimension/delete", payload);
	return response.data;
};

export const useDeleteCategoryDimension = () => {
	return useMutation({
		mutationFn: deleteCategoryDimension,
	});
};
